import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import router from './router/index'
import store from './store/index'
if (process.env.VUE_APP_STYLE_NAME) {
    require('./styles/style.'+process.env.VUE_APP_STYLE_NAME+'.scss');
}else{
    require('./styles/style.scss')
}
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios"

axios.interceptors.request.use(
    config => {
        
        
        let basePath = process.env.VUE_APP_BASE_PATH
        config.url = basePath + config.url
        const token = localStorage.getItem('token_id');
      
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;    
        }
            
        config.headers['Content-Type'] = 'application/json';
        /* if(process.env.MIX_ADD_BACKSLASH_AXIOS_URL){
            config.url = config.url + '/'
        } */
        return config;
    },
    error => {
        Promise.reject(error)
});


createApp(App).use(router).use(store).mount(process.env.VUE_APP_DOM_START_ID || '#app');
